import React, {useEffect, useState} from "react";
import {FormControl, MenuItem, Select} from "@mui/material";

const AssigneeDropdown = ({cell, row, rowIndex, supportUsers, handleUpdateCellCallBack}) => {
    const [selectedValue, setSelectedValue] = useState(cell.getValue() || '');

    useEffect(() => {
        setSelectedValue(cell.getValue() || '');
    }, [cell]);

    const handleChange = (event) => {
        setSelectedValue(event.target.value);
        handleUpdateCellCallBack(row.original.id, 'assignee', event.target.value, row.original);
    };

    return (
        <FormControl sx={{width:'9.375rem',}}>
            <Select
                labelId={`assignee-select-label-${rowIndex}`}
                id={`assignee-select-${rowIndex}`}
                value={selectedValue}
                onChange={handleChange}
                displayEmpty
                inputProps={{'aria-label': 'Without label'}}
                sx={{
                    height: '1.563rem',
                    '.MuiSelect-select': {
                        paddingTop: '0.375rem',
                        paddingBottom: '0.375rem',
                    },
                }}
            >
                <MenuItem value="">
                    <em>None</em>
                </MenuItem>
                {supportUsers.map((user) => (
                    <MenuItem key={user.id} value={user.name}>{user.name}</MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default AssigneeDropdown;
